import { customerRoutes } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { useNavigate } from 'react-router-dom';

/**
 * After the user leaves a group. The session still points at the group they left (the id lives in
 * session storage): a fresh token login rewrites it from the new memberships, and the picker sends
 * them on -- straight through when only one group is left. Navigates even if that refresh fails; a
 * page scoped to a group the user just left can only 403.
 */
export const useReturnToGroupPicker = () => {
  const { tokenLoginOfUsers } = useAuthContext();
  const navigate = useNavigate();

  return () => {
    void (async () => {
      try {
        await tokenLoginOfUsers();
      } catch {
        // Handled by navigating anyway.
      }
      navigate(customerRoutes.userSelection.getPath());
    })();
  };
};
